import { render, staticRenderFns } from "./LocalityShowData.vue?vue&type=template&id=6441746b&"
import script from "./LocalityShowData.vue?vue&type=script&lang=js&"
export * from "./LocalityShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports